import React, { useEffect, useState } from "react";
import { useError } from "../../context/errorContext";
import axiosInstance from "../../api/axiosInstance";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import moment from "moment/moment";
import "./deliveryNotes.scss"

const DeliveryNotes = () => {
    const [deliveryNotes, setDeliveryNotes] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [year, setYear] = useState(new Date().getFullYear());

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

    const { showMessage } = useError();

    useEffect(() => {
        const fetchAllRef = async () => {
            try {
                const [deliveryNotesRes] = await Promise.all([
                    axiosInstance.get(`ergo/deliverynotes/${year}`)
                ]);

                setDeliveryNotes(deliveryNotesRes.data || []);
                setLoading(false);
            } catch (err) {
                console.log(err)
            }
        }
        fetchAllRef()
    }, [year])

    const changeYear = (e) => {
        setYear(Number(e.target.value));
    };

    const openDocument = async (customerId, fileName) => {
        try {
            const res = await axiosInstance.get(`files/deliverynote/${customerId}/${fileName}`, {
                responseType: 'blob',
            });
            console.log(fileName)
            const fileURL = URL.createObjectURL(res.data);
            window.open(fileURL, "_blank");
        } catch (err) {
            const blob = err.response?.data;

            if (blob instanceof Blob) {
                const { error } = JSON.parse(await blob.text());
                showMessage(error);
            } else {
                showMessage(err.message);
            }
        }
    };

    if (isLoading) return <div className="loading" />

    const hasData = deliveryNotes && deliveryNotes.length > 0;
    if (!hasData)
        return (
            <div className="deliveryNotes">
                <div className="container">
                    <div className="header">
                        <h1>Lieferscheine</h1>
                    </div>
                    <div className="noData">
                        <span>Keine Lieferscheine gefunden.</span>
                    </div>
                </div>
            </div>
        );

    return (
        <div className="deliveryNotes">
            <div className="container">
                <div className="header">
                    <h1>Lieferscheine</h1>
                </div>
                <div className="content">
                    <div className="filter">
                        <div className="group">
                            <span>Jahr</span>
                            <select className="year" value={year} onChange={changeYear}>
                                {years.map(y => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="tableWrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Nr.</th>
                                    <th>Datum</th>
                                    <th>Bestimmungsort</th>
                                    <th>Transportmittel</th>
                                    <th className="options"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {deliveryNotes.map((item, index) => (
                                    <tr key={index}
                                        onClick={() =>
                                            openDocument(item.COMPANYID, `LF_${item.SERIALYEAR}_${item.SERIALNR}_${item.DOCID}.pdf`)
                                        }
                                    >
                                        <td>{item.SERIALNR}/{item.DOCID}</td>
                                        <td>{moment(item.CREATED.replace("Z", "")).format("DD.MM.YYYY HH:mm")}</td>
                                        <td>
                                            {item.DESTNAME1}<br />
                                            {item.ZIP} {item.PLACE}
                                        </td>
                                        <td>{item.REGISTRATION}</td>
                                        <td className="options">
                                            <div className="controls">
                                                <DescriptionOutlinedIcon />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div >
    )
};

export default DeliveryNotes